import {
  FollowType,
  FollowedArtistsResponse,
} from '@bonhams1793/bonhams-typescript'

import { BonhamsCookies } from '@nx/global-types'
import { logger } from '@nx/utils/logger'

import { getFollowedByType } from '../followApi'

export async function getFollowedArtists(
  userId: number,
  cookies: BonhamsCookies,
  baseUrl: string
): Promise<number[]> {
  try {
    const response = await getFollowedByType<FollowedArtistsResponse>({
      userId,
      type: FollowType.artist,
      cookies,
      baseURL: baseUrl,
    })

    return response.data.map((item) => item.iArtistNo)
  } catch (error) {
    logger.error(error, `Could not fetch artist likes for user ${userId} `)
    return []
  }
}
